export const VARIANT = {
    SOLID: 0,
    CLEAR: 1
};

export const POSITION = {
    LEFT: 0,
    RIGHT: 1
};